<template>
  <el-dialog class="dialog" :visible="true" :append-to-body="true" :close-on-click-modal="true" @close="closeDialog()" @open="handleOpen()">
    <div class="dialog-programs dialog__inner">
      <div class="dialog-programs__column dialog-programs__column_aside">
        <div slot="title" class="dialog__head dialog__head_second">
          <div class="dialog__head-inner">
            <h2 class="dialog__title">{{ !orkInfo.editable ? 'Список образовательных программ' : 'Укажите соответствующую образовательную программу' }}</h2>
          </div>
        </div>

        <div v-if="orkInfo.editable" style="margin-bottom: 15px;">
          <button type="button" class="btn btn_action-second btn_full" @click="$emit('openExternalProgramDialog');">
            Посмотреть другие программы
          </button>
        </div>

        <button type="button" class="btn btn_action-second btn_full mb-16" :disabled="createEntity" @click="createProgram">
          Добавить новую программу
          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
        </button>



        <form action="#" @submit.prevent="submitSelected">
          <div class="programs-list programs-list_vertical dialog-programs__programs-list">
            <div class="programs-list__inner">
              <el-checkbox-group v-model="selection">
                <div class="programs-list__item" v-for="item in allPossibleEducationPrograms" :key="item.id" @click="editProgram(item)">
                  <div class="programs-list__content">
                    <div class="programs-list__content-item programs-list__content-item_main">
                                            <span class="programs-list__checkbox-wrap" style="display:flex;">
                                                <el-checkbox class="programs-list__checkbox" v-if="orkInfo.editable" :checked="programsFromOpenedTraining.some(program => program.id === item.id)" :label="item.id"/>
                                                <span class="programs-list__text" v-html="item.name"></span>
                                            </span>
                    </div>

                    <div class="programs-list__content-item">


                      <div class="programs-list__extra" v-if="item.external">
                        <icon-base viewBox="0 0 21 20" class="programs-list__cloud">
                          <icon-cloud />
                        </icon-base>
                      </div>
                    </div>
                  </div>

                  <footer class="programs-list__footer">
                    Повышение квалификации

<!--                    <icon-base viewBox="0 0 8 14" class="programs-list__more">-->
<!--                      <icon-arrow-right />-->
<!--                    </icon-base>-->
                  </footer>
                </div>
              </el-checkbox-group>
            </div>
          </div>

          <footer class="dialog-programs__footer">
            <button v-if="orkInfo.editable" type="submit" class="btn btn_action ml-auto">
              Добавить выбранные программы
            </button>
          </footer>
        </form>
      </div>

      <div class="dialog-programs__column dialog-programs__column_main" :class="{ 'is-active': createEntity }">
        <div class="program">
          <form @submit.prevent="createItem">
            <header class="program__head">
              <h2 class="dialog__title">Новая образовательная программа</h2>
            </header>

            <div class="program__content">
              <section class="program__section">
                <h2 class="program__title">Основная информация</h2>

                <input type="text" name="name" class="input" placeholder="Название" required>

                <textarea name="description" class="textarea mt-8" placeholder="Краткое описание"></textarea>

                <v-select class="select mt-8" placeholder="Форма обучения" label="name" name="education_form_id" v-model="select" :clearable="false" :options="educationForms">
                  <template #search="{attributes, events}">
                    <input
                        class="vs__search"
                        v-bind="attributes"
                        v-on="events"
                        :required="!select"
                    />
                  </template>
                  <template #no-options="{ search, searching, loading }">
                    {{ SELECT_NOT_FOUND }}
                  </template>
                  <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                  </template>
                </v-select>
              </section>

              <section class="program__section">
                <h2 class="program__title">Контакты организации</h2>

                <h4>Название организации</h4>

                <div class="contacts">
                  <div class="contacts__row">
                    <div class="contacts__item">
                      <input type="text" name="contact_name" class="input" placeholder="Название организации" required>
                    </div>

                    <div class="contacts__item">
                      <masked-input name="contact_phone" mask="\+\7 (111) 111-11-11" class="input" placeholder="Телефон" required />
                    </div>
                  </div>
                  <div class="contacts__row">
                    <div class="contacts__item">
                      <input type="text" name="contact_address" class="input" placeholder="Адрес организации" required>
                    </div>

                    <div class="contacts__item">
                      <input type="text" name="contact_link" class="input" placeholder="Ссылка на сайт" required>
                    </div>
                  </div>
                  <div class="contacts__row">
                    <div class="contacts__item">
                      <input type="text" name="program_link" class="input" placeholder="Ссылка на детальную страницу о программе">
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <footer class="dialog-programs__footer">
              <button type="submit" class="btn btn_primary ml-auto">
                Добавить программу
              </button>
            </footer>
          </form>
        </div>
      </div>

      <div class="dialog-programs__column dialog-programs__column_main" :class="{ 'is-active': activeProgram && showItem }" v-if="activeProgram">
        <div v-if="activeProgram.external">
          <header class="program__head">
            <h2 class="dialog__title">Образовательная программа</h2>
          </header>

          <div class="program__content">
            <section class="program__section">
              <h2 class="program__title">Основная информация</h2>

              <span class="input" v-html="activeProgram.name"></span>

              <span class="textarea mt-8" v-html="activeProgram.description" v-if="activeProgram.description"></span>

              <span class="input mt-8" v-html="editSelect.name"></span>
            </section>

            <section class="program__section">
              <h2 class="program__title">Контакты организации</h2>

              <h4>Название организации</h4>

              <div class="contacts">
                <div class="contacts__row">
                  <div class="contacts__item">
                    <span class="input" v-html="activeProgram.contact ? activeProgram.contact.name : ''"></span>
                  </div>

                  <div class="contacts__item">
                    <span class="input" v-html="activeProgram.contact ? activeProgram.contact.phone : ''"></span>
                  </div>
                </div>
                <div class="contacts__row">
                  <div class="contacts__item">
                    <span class="input" v-html="activeProgram.contact ? activeProgram.contact.address : ''"></span>
                  </div>

                  <div class="contacts__item">
                    <span class="input" v-html="activeProgram.contact ? activeProgram.contact.link : ''"></span>
                  </div>
                </div>
                <div class="contacts__row" v-if="activeProgram.program_link">
                  <div class="contacts__item">
                    <span class="input" v-html="activeProgram.program_link"></span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <form class="program__form" autocomplete="off" @submit.prevent="editItem" :key="activeProgram.id" v-else>
          <header class="program__head">
            <h2 class="dialog__title">{{ mode === 'interrelations' ? 'Образовательная программа' : 'Редактировать образовательную программу' }}</h2>
          </header>

          <div class="program__content">
            <section class="program__section">
              <h2 class="program__title">Основная информация</h2>

              <input type="text" name="name" class="input" placeholder="Название" :readonly="mode === 'interrelations'" :value="activeProgram.name" required>

              <textarea name="description" class="textarea mt-8" placeholder="Краткое описание" :readonly="mode === 'interrelations'" v-html="activeProgram.description"></textarea>

              <v-select class="select mt-8" placeholder="Форма обучения" label="name" name="education_form_id" :clearable="false" :options="educationForms" v-model="editSelect">
                <template #search="{attributes, events}">
                  <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                      :required="!editSelect"
                  />
                </template>
                <template #no-options="{ search, searching, loading }">
                  {{ SELECT_NOT_FOUND }}
                </template>
                <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes">
                                        <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                    </span>
                </template>
              </v-select>

              <input v-if="mode === 'interrelations'" type="text" name="education_form_id" class="input mt-8" placeholder="Форма обучения" :readonly="mode === 'interrelations'" :value="editSelect.name" required>
            </section>

            <section class="program__section">
              <h2 class="program__title">Контакты организации</h2>

              <h4>Название организации</h4>

              <div class="contacts">
                <div class="contacts__row">
                  <div class="contacts__item">
                    <input type="text" name="contact_name" class="input" placeholder="Название организации" :value="activeProgram.contact ? activeProgram.contact.name : ''" :readonly="mode === 'interrelations'" required>
                  </div>

                  <div class="contacts__item">
                    <masked-input name="contact_phone" mask="\+\7 (111) 111-11-11" class="input" placeholder="Телефон" :value="activeProgram.contact ? activeProgram.contact.phone : ''" :readonly="mode === 'interrelations'" required />
                  </div>
                </div>
                <div class="contacts__row">
                  <div class="contacts__item">
                    <input type="text" name="contact_address" class="input" placeholder="Адрес организации" :value="activeProgram.contact ? activeProgram.contact.address : ''" :readonly="mode === 'interrelations'" required>
                  </div>

                  <div class="contacts__item">
                    <input type="text" name="contact_link" class="input" placeholder="Ссылка на сайт" :value="activeProgram.contact ? activeProgram.contact.link : ''" :readonly="mode === 'interrelations'" required>
                  </div>
                </div>
                <div class="contacts__row">
                  <div class="contacts__item">
                    <input type="text" name="program_link" class="input" placeholder="Ссылка на детальную страницу о программе" :value="activeProgram.program_link" :readonly="mode === 'interrelations'">
                  </div>
                </div>
              </div>
            </section>
          </div>

        </form>
      </div>
    </div>
  </el-dialog>

</template>

<script>
import dialog from "@/mixins/dialog";
import {mapActions, mapState} from "vuex";
import MaskedInput from 'vue-masked-input';
import _ from "lodash";
import constants from "@/constants";

export default {
  name: "TrainingProgramsDialog",
  mixins: [ dialog ],
  components: {MaskedInput},
  props: {
    training: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      programs: [],
      selection: [],
      editSelect: null,
      activeProgram: null,
    }
  },
  computed: {
    ...mapState('editor', ['orkInfo', 'programsFromOpenedTraining', 'programsByQualificationFromNSI', 'programsByQualification']),
    ...mapState('listsForEditor', ['educationForms']),

    allPossibleEducationPrograms() {
      // включает в себя ОП из НСИ, созданные и привязанные к квалификации внутри ОРК
      let arr = this.programsFromOpenedTraining.concat(this.programsByQualificationFromNSI);
      arr = arr.concat(this.programsByQualification);

      const ids = arr.map(o => o.id);
      const filtered = arr.filter(({id}, index) => !ids.includes(id, index + 1));
      return filtered;
    }
  },
  methods: {
    ...mapActions('editor', [
        'LOAD_PROGRAMS_BY_TRAINING',
        'LOAD_PROGRAMS_BY_QUALIFICATION_FROM_NSI',
        'LOAD_PROGRAMS_BY_QUALIFICATION',
        'UPDATE_TRAININGS',
        'CREATE_PROGRAM',
    ]),

    ...mapActions('listsForEditor', [
        'LOAD_EDUCATION_FORMS'
    ]),

    editProgram(program) {
      this.createEntity = false;
      this.showItem = true;
      this.activeProgram = program;
      // this.editSelect = this.educationForms.find(el => el.id === this.activeProgram.education_form_id);
    },
    async closeDialog() {
      this.$emit('close');
      this.elDialogs.programs = false;
    },

    createProgram() {
      this.createEntity = true;
      this.showItem = false;
    },

    async submitSelected() {
        const ids = [...new Set(this.selection)];

        const params = {
          trainingId: this.training.id,
          ids
        }

        await this.UPDATE_TRAININGS(params);
        await this.LOAD_PROGRAMS_BY_TRAINING(this.training.id);
        await this.LOAD_PROGRAMS_BY_QUALIFICATION_FROM_NSI(this.training.qualification_to.id);
        await this.LOAD_PROGRAMS_BY_QUALIFICATION(this.training.qualification_to.id);

        await this.closeDialog();
    },

    async createItem(e) {
      // Собираем новые значения и отправляем
      const formData = new FormData(e.target);

      const params = {
        contact: {},
        education_form_id: this.select.id,
        qualification_id: this.training.qualification_to.id,

        // Бэк ожидает массива, не знаю почему
        trainings: [this.training],

      };

      for (const pair of formData.entries()) {
        if (!pair[0].startsWith('contact')) {
          params[pair[0]] = pair[1];
        } else {
          params.contact[pair[0].slice(pair[0].indexOf('_') + 1)] = pair[1];
        }
      }

      const newProgram = await this.CREATE_PROGRAM(params);
      this.selection.push(newProgram.id)

      e.target.reset();
    },
  },

  async mounted() {
      await this.LOAD_PROGRAMS_BY_TRAINING(this.training.id);
      await this.LOAD_PROGRAMS_BY_QUALIFICATION_FROM_NSI(this.training.qualification_to.id);
      await this.LOAD_PROGRAMS_BY_QUALIFICATION(this.training.qualification_to.id);
      await this.LOAD_EDUCATION_FORMS();
  },

  created() {
    this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
  }
}
</script>
